import RequestsGridItem from './RequestsGridItem'

export default function RequestsGrid({ requests }) {
  return (
    <div className="grid grid-cols-12 gap-2">
      {requests?.map((request) => (
        <RequestsGridItem
          key={request.id}
          request={request}
        />
      ))}
    </div>
  )
}
